// 日记分享单个事件
import React, { useEffect, useState } from 'react';
import { useRouteMatch, useHistory, useLocation, useParams } from "react-router-dom";
import { Modal, Toast } from 'antd-mobile';
import classnames from 'classnames';
import '../css/NoteShare.scss';
import NoteShareService from '../services/NoteShare';
import { getWeek,  getParameter, getCookie } from '../utils/func';
import moment from 'moment';

const NoteShare = ({ props }) => {
    const match = useRouteMatch();
    const location = useLocation();
    const history = useHistory();
    const params = useParams();
    const APPID = 'wx754e1b2a81936e91' // appid
    // console.log(match, location, history, params);
    const [noteDetail, setNoteDetail] = useState({ address: "" });
    const [isShow, setIsShow] = useState(false);
    const [user, setUser] = useState({});
    const [orderData, setOrderData] = useState({});
    const [timer, setTimer] = useState(null);
    useEffect(() => {
        document.cookie = "noteUid=123"
        const noteUid = getParameter("noteUid", location.search);
        console.log(getCookie("noteUid"));
        NoteShareService.getArticleDetail({ uuid: params.id, uid: ( getCookie("noteUid") && localStorage.getItem("noteUid") ) || '' }).then(res => {
            console.log(res);
            document.title = res.data.title;
            setNoteDetail(res.data);
            setIsShow(true);
        }).catch(error => { error.message && Toast.info(error.message); setIsShow(false) })
    }, []);
    // useEffect(() => {
    //     return () => {
    //         alert("退出")
    //         localStorage.removeItem("noteUid");
    //     };
    // }, [])
    const browser = {
        versions: function () {
            var u = navigator.userAgent, app = navigator.appVersion;
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                souyue: u.indexOf('souyue') > -1,
                superapp: u.indexOf('superapp') > -1,
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == " qq", //是否QQ
                Safari: u.indexOf('Safari') > -1
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    useEffect(() => {
        const code = getParameter("code");
        if (code && browser.versions.weixin) {
            isRegister();
        }
    }, []);
    const openTodoApp = () => {
        if (browser.versions.weixin) {
            if (browser.versions.ios) {
                window.location.href = "https://www.kairusi.com/1notes/detail?uuid=" + params.id;
            } else if (browser.versions.android) {
                window.location.href = "https://www.kairusi.com/1notes/detail?uuid=" + params.id;
                // history.push('/download?uuid=' + params.id);
            }
        } else {
            if (browser.versions.android) {
                window.location.href = "noteapp://note.app/open?uuid=" + params.id;
                window.setTimeout(function () {
                    history.push('/download?uuid=' + params.id);
                }, 2000);
            } else if (browser.versions.ios){
                window.location.href = "https://www.kairusi.com/1notes/detail?uuid=" + params.id;
                // window.setTimeout(function () {
                //     history.push('/download?uuid=' + params.id);
                // }, 2000);
            }
        }
    };
    const download = () => {
        // window.location.href = "https://itunes.apple.com/cn/app/id1519927147?mt=8";
        // window.location.href = `http://mp.weixin.qq.com/mp/redirect?url=${encodeURIComponent('http://itunes.apple.com/cn/app/id1519927147?mt=8')}`
        if (browser.versions.weixin) {
            if (browser.versions.ios) {
                window.location.href = "https://itunes.apple.com/cn/app/id1551902709";
            } else if (browser.versions.android) {
                window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist";
            }
        } else {
            if (browser.versions.android) {
                window.location.href = "http://download.kairusi.com/1TodoS/1TodoS.apk";
            } else if (browser.versions.ios) {
                window.location.href = "https://itunes.apple.com/cn/app/id1551902709";
            }
        }
    };
    // 微信授权
    const toWxpayAuth = () => {
        console.log(window.location.protocol + "//" + window.location.host + "/web/mobile#" + location.pathname + location.search);
        // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://127.0.0.1:3000" + "/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/rike/mobile#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    };
    // 是否注册过
    const isRegister = () => {
        const code = getParameter("code");
        NoteShareService.checkRegister({ code }).then(res => {
            if (res.data.u_id === "0") {
                openTodoApp();
            } else {
                setUser(res.data);
                localStorage.setItem("noteUid", res.data.u_id);
                document.cookie = "noteUid=" + res.data.u_id;
                NoteShareService.getArticleDetail({ uuid: params.id, uid: res.data.u_id }).then(res2 => {
                    console.log(res);
                    document.title = res2.data.title;
                    setNoteDetail(res2.data);
                    setIsShow(true);
                    if (!res2.data.is_buy) {
                        createOrder(res.data);
                    }
                }).catch(error => { error.message && Toast.info(error.message); setIsShow(false) })
            }
        }).catch(error => { })
    };
    // 创建订单
    const createOrder = (userObject) => {
        const token = getParameter("token", location.search);
        NoteShareService.createOrder({ u_id: userObject.u_id, openid: userObject.openid, share_token: token, uuid: params.id }).then(res => {
            setOrderData(res.data);
            localStorage.setItem("orderWx", JSON.stringify(res.data));
            toPay(res.data, userObject);
        }).catch(error => {
            error.message && Toast.info(error.message, 3);
            setTimeout(() => {
                window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/diaryDetail/" + params.id + "?token=" + token);
            }, 3000);
        })
    };
    // 查询订单
    const getOrderStatus = (userObject) => {
        const token = getParameter("token", location.search);
        NoteShareService.getOrderStatus({ order_sn: JSON.parse(localStorage.getItem("orderWx")).order_sn }).then(payInfo => {
            if (payInfo.data.status === 1) {
                clearInterval(timer);
                localStorage.removeItem("orderWx");
                Toast.info('支付成功', 2);
                setTimeout(() => {
                    window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/diaryDetail/" + params.id + "?token=" + token + "&noteUid=" + userObject.u_id);
                }, 2000);
            }
        }).catch(error => {
            error.message && Toast.info(error.message, 2);
            setTimeout(() => {
                localStorage.removeItem("noteUid");
                window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/diaryDetail/" + params.id + "?token=" + token);
            }, 2000);
        })
    };
    const onBridgeReady = (wxpayData, userObject) => {
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
            "appId": wxpayData.appid,     //公众号名称，由商户传入     
            "timeStamp": wxpayData.timestamp,         //时间戳，自1970年以来的秒数     
            "nonceStr": wxpayData.nonce_str, //随机串     
            // "package": "prepay_id=" + wxpayData.prepay_id,
            "package": wxpayData.package,
            "signType": "MD5",         //微信签名方式：     
            "paySign": wxpayData.sign //微信签名 
        },
            function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    if (localStorage.getItem("orderWx") && JSON.parse(localStorage.getItem("orderWx")).order_sn) {
                        setTimer(setInterval(() => {
                            getOrderStatus(userObject);
                        }, 1000))
                    }
                } else {
                    const token = getParameter("token", location.search);
                    localStorage.removeItem("orderWx");
                    window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/diaryDetail/" + params.id + "?token=" + token);
                }
            });
    };
    // 立即支付
    const toPay = (wxpayData, userObject) => {
        if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady(wxpayData, userObject), false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady(wxpayData, userObject));
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(wxpayData, userObject));
            }
        } else {
            onBridgeReady(wxpayData, userObject);
        }
    };
    return <div className={classnames("note-share", { "note-share-pay": !noteDetail.is_buy, "note-share-none": !isShow })}>
        <div className="header">
            <div className="header-left">
                <img src={require("../image/logo.png")} className="header-img" alt="" />
                <div className="header-text">1NoteS·随时随地记录美好</div>
            </div>
            <div className="header-button" onClick={download}>下载</div>
            {/* <a href={`http://mp.weixin.qq.com/mp/redirect?url=${encodeURIComponent('itms-apps://itunes.apple.com/cn/app/id1519927147?mt=8')}`}>itms下载todo</a> */}
            {/* <a href={`http://mp.weixin.qq.com/mp/redirect?url=${encodeURIComponent('http://itunes.apple.com/cn/app/id1519927147?mt=8')}`}>下载todo</a> */}
            {/* <a href={`http://mp.weixin.qq.com/mp/redirect?url=${encodeURIComponent('http://www.baidu.com')}`}>跳转百度</a> */}
            {/* <a href="http://mp.weixin.qq.com/mp/redirect?url=http%3A%2F%2Fitunes.apple.com%2Fus%2Fapp%2Fid399608199%23rd">download</a> */}
        </div>
        <div className={classnames("note-wrapper", { "note-wrapper-pay": !noteDetail.is_buy })}>
            <div className="note-title">{noteDetail.title}</div>
            <div className="note-date">{moment(Number(noteDetail.weekday)).format('YYYY-MM-DD')}周{getWeek(Number(noteDetail.weekday))} 于 {noteDetail.address && JSON.parse(noteDetail.address).province}·{noteDetail.address && JSON.parse(noteDetail.address).city}（{noteDetail.weather}）</div>
            <div className="note-html" dangerouslySetInnerHTML={{ __html: noteDetail.content_html }}></div>
            <div className={classnames("note-footer", { "note-footer-none": !noteDetail.is_buy })}>©著作权归作者所有</div>
            <div className={classnames("note-open", { "note-open-none": !noteDetail.is_buy })} onClick={openTodoApp}>打开APP，给TA点赞互动</div>
        </div>
        <div className={classnames("note-pay-bac", { "note-pay-bac-none": noteDetail.is_buy})}>
            <div className="note-footer">还有更多精彩内容</div>
            <div className="note-open" onClick={toWxpayAuth}>支付¥{noteDetail.fee / 100}以继续阅读</div>
        </div>
    </div>
};

export default NoteShare;